<template>
  <MessageLayout
    image="./set-credentials-error.svg"
    altText="set credentials error"
    title="Sorry!"
    :contact-url="contactUrl"
  >
    There was an issue with setting your password, please try again or
    <a :href="contactUrl">contact</a> us.
    <template v-slot:action>
      <el-button @click="tryAgain">Try Again</el-button>
    </template>
  </MessageLayout>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import MessageLayout from "@/modules/messages/MessageLayout.vue";
import ResendEmail from "@/modules/ResendEmail.vue";
import { RoutesName } from "@/router";
import { configService } from "@/services/config-service";
import store from "@/store";

@Options({
  components: { ResendEmail, MessageLayout },
})
export default class SentCredentialsError extends Vue {
  readonly contactUrl = configService.supportUrl;
  $store = store;

  get email(): string {
    return this.$store.getters.prospect;
  }

  tryAgain(): void {
    this.$router.push({
      name: RoutesName.SET_CREDENTIALS,
      params: { jwt: this.$store.getters.jwt },
    });
  }
}
</script>
